import { useSelector } from "react-redux";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import { getClientConfig } from "../../../config/runtimeConfig";
import { useCallback } from "react";
import { GoalType } from "../../types/enums";
import useMetrics from "../../hooks/useMetrics";

export const useCallButton = () => {
  const cluster = useSelector(selectCurrentCluster);
  const config = getClientConfig();
  const phoneNumber = cluster?.phone_number || "";
  const { trackGoal } = useMetrics();

  const handleCall = useCallback(() => {
    if (!phoneNumber) return;
    trackGoal(GoalType.CALL_CLICK, phoneNumber);
    window.location.href = `tel:${phoneNumber}`;
  }, [phoneNumber, trackGoal]);

  const visible = config.callButton === true && !!phoneNumber;

  return { handleCall, visible };
};
